<template>
	<div class="az-container card-juntar-termo arp-text-color">
		<div class="mensagem-juntada">
			<template v-if="!passoJuntadaFinalizado">
				<div id="informacaoJuntar" style="max-width: 500px">
					<h1>Gostaria de juntar o termo ao processo digital?</h1>
					<p>
						Clique no botão de Juntar se deseja realmente juntar o termo de desentranhamento do documento
						<b>{{ tituloDocumento }}</b> no processo digital. O termo irá substituir às pgs.
						<b>{{ primeiraPagina + ' a ' + ultimaPagina }}</b
						>.
					</p>
				</div>
				<div class="pb-3">
					<botao-primario
						id="botaoJuntar"
						nome-botao="Juntar"
						@click="$emit('juntar-termo')"
					></botao-primario>
				</div>
			</template>
			<template v-else>
				<div style="max-width: 500px">
					<h1>Termo juntado no processo digital!</h1>
				</div>
			</template>
			<div>
				<az-call-to-action
					id="botaoVoltar"
					key="notFound"
					css-class="action-primary"
					style="margin-bottom: 20px"
					@click="$emit('voltar')"
				>
					Ir para Documentos
				</az-call-to-action>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'termo-desentranhamento-juntar',
	props: {
		tituloDocumento: {
			type: String,
			default: null,
		},
		passoJuntadaFinalizado: {
			type: Boolean,
		},
		primeiraPagina: {
			type: Number,
			default() {
				return null
			},
		},
		ultimaPagina: {
			type: Number,
			default() {
				return null
			},
		},
	},
}
</script>

<style lang="stylus" scoped>
.card-juntar-termo
	display flex
	justify-content center
	align-items center
	height calc(100vh - 400px)

	.mensagem-juntada
		text-align center
</style>
